module.exports = __webpack_public_path__ + "static/media/arrow_down_red.799d40b9.svg";